import { Paper, Typography } from "@mui/material";

import { useAIChat } from "./hooks/useAIChat";
import { styles } from "./styles";

import { AIChatHeader } from "./components/aiChatHeader";
import { AIChatContent } from "./components/aiChatContent";
import { AIChatFooter } from "./components/aiChatFooter";
import CircularSpinner from 'components/display/circularSpinner';
import { useTranslation } from "utils/locales/utilityFunctions";

type Props = {
  onClose: () => void;
};

export function AIChatModal({ onClose }: Props) {
  const { messages, isLoading, isLoadingThread, reset, sendMessage } = useAIChat();
  const { translate } = useTranslation();

  return (
    <Paper sx={styles.modal} elevation={20}>
      <AIChatHeader onClose={onClose} />

      {isLoadingThread && (
        <div style={{ display: "flex", flexDirection: "column", height: "100%", alignItems: "center", justifyContent: "center" }}>
          <CircularSpinner loading={true} variant="iconButton" color="secondary" />

          <Typography color="secondary" sx={{ opacity: 0.8, mt: 0.5 }}>
            {translate("ai-chat-feedback-getting-thread")}
          </Typography>
        </div>
      )}

      {!isLoadingThread && (
        <AIChatContent messages={messages} onReset={reset} onSendMessage={sendMessage} />
      )}

      <AIChatFooter sendMessage={sendMessage} isLoading={isLoading} />
    </Paper>
  );
}
